module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/hihoo/ibilling/attendence/public/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0